import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import type { ConversationBillingState } from '@/utils/conversationBilling';

interface ConversationBillingBadgeProps {
  state: ConversationBillingState;
  className?: string;
}

const ConversationBillingBadge: React.FC<ConversationBillingBadgeProps> = ({
  state,
  className = '',
}) => {
  const { t } = useTranslation();

  if (state === 'billable') return null;

  const label = t(
    'agent.conversations.billing.not_counted.label.translation',
    'Not counted'
  );

  const description =
    state === 'before_subscription'
      ? t(
          'agent.conversations.billing.before_subscription.description.translation',
          'This call happened before the subscription was activated, so it is not counted towards plan usage.'
        )
      : t(
          'agent.conversations.billing.outside_subscription.description.translation',
          'This call happened outside an active subscription period, so it is not counted towards plan usage.'
        );

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            onClick={event => event.stopPropagation()}
            className={`inline-flex flex-shrink-0 items-center rounded-md border border-border bg-muted px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-muted-foreground ${className}`}
          >
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[16rem]">
          <p className="text-xs">{description}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ConversationBillingBadge;
